export class LocationContext {
    path: string | null = null;
}
